import { createAction, props } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { EstruturaRetornoOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno.output.dto";
import { PaginaJornalOutputDto } from "src/app/domain/DTOs/output/jornal/pagina-jornal.output.dto";

const actionName = "[ ObterPaginaJornalPorAutenticidade ] Obter Página Jornal por código de Autenticidade";

export const obterPaginaJornalPorAutenticidade = createAction(
  actionName,
  props<{ inputDto: string}>()
);

export const obterPaginaJornalPorAutenticidadeSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<PaginaJornalOutputDto> }>()
);

export const obterPaginaJornalPorAutenticidadeFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<PaginaJornalOutputDto> }>()
);

export const obterPaginaJornalPorAutenticidadeCatchError = createAction(
  `${actionName} - Falha - CatchError`,
  props<{ response: EstruturaRetornoOutputDto }>()
);

export const obterPaginaJornalPorAutenticidadeFinish = createAction(
  `${actionName} - Concluir`
);
